import React from "react";
import ShareRow from "./ShareRow";
import { trackAsk } from "../lib/askTrack";

/**
 * The Ask Cassie flavour of the share row: identical controls, with the click
 * also landing in the Ask Cassie visitor figures so the admin can see which
 * answers people pass on.
 */
export const ShareAnswer = ({ path, title, slug, className = "" }) => (
  <ShareRow
    path={path}
    title={title}
    className={className}
    onTrack={(network) => trackAsk("outbound", { page: "answer", slug, target: `share-${network}` })}
  />
);

export default ShareAnswer;
